import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export type ContainerProps = {
    alignment: string
    loaded: boolean
}

export const Container = styled("ul", {
    shouldForwardProp: prop => !["loaded", "alignment"].includes(prop as string),
})<ContainerProps>`
    width: 100%;
    height: 100%;
    border-top-style: none;
    display: flex;
    opacity: var(--display-primary-nav, 0);
    align-items: center;
    flex-direction: row;
    padding: 0;
    margin: 0;
    -ms-overflow-style: none;
    overflow-x: scroll;
    overflow-y: hidden;
    scroll-behavior: ${({loaded}) => (loaded ? "smooth" : "auto")};
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: ${breakpoints.values.lg - 1}px) {
        padding-left: 0;
        padding-right: 0;

        @media (min-width: ${breakpoints.values.md}px) {
            padding-left: 1.565rem;
            padding-right: 1.565rem;
        }
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        padding-left: 1.565rem;
        padding-right: 1.565rem;

        @media (min-width: ${breakpoints.values.xl}px) {
            padding-left: 1.8125rem;
            padding-right: 1.8125rem;
        }
    }
`
